<script setup lang="ts">
// legNumber: an itinerary can pass the same city twice, and the title alone would name two sliders alike.
withDefaults(defineProps<{ title: string; cityCode?: string; legNumber?: number; size?: 's' | 'm' }>(), {
  cityCode: undefined,
  legNumber: undefined,
  size: 'm',
});

const model = defineModel<{ start: number; end: number }>({ required: true });

const locationLabels = useLocationLabels();
</script>

<template>
  <UiCustomFilterLabeledSlider
    v-model="model"
    :size="size"
    :min="0"
    :max="24"
    :step="1"
    :format-value="formatHour"
    :title="`${title} ${locationLabels.city(cityCode)}`"
    :hidden-title-prefix="legNumber ? `${$t('components.results.filters.leg')} ${legNumber}` : undefined"
  >
    <template #labels="{ start, end }">
      <span>{{ formatHour(start) }}</span>
      <span>{{ formatHour(end) }}</span>
    </template>
  </UiCustomFilterLabeledSlider>
</template>
